import {Pipe, PipeTransform} from "@angular/core";

@Pipe({name: 'roleText'})
export class RoleTextPipe implements PipeTransform {
  transform(value: string): any {
    if (value == 'ROLE_USER') return '일반멤버';
    if (value == 'ROLE_MANAGER') return '매니저';
    if (value == 'ROLE_ADMIN') return '관리자';
    return '';
  }
}



// WEBPACK FOOTER //
// ./src/app/pipe/role-text.pipe.ts